import { render, staticRenderFns } from "./ExpedientProfitabilityWidget.vue?vue&type=template&id=45f7b7aa&scoped=true"
import script from "./ExpedientProfitabilityWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpedientProfitabilityWidget.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ExpedientProfitabilityWidget.vue?vue&type=style&index=0&id=45f7b7aa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f7b7aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45f7b7aa')) {
      api.createRecord('45f7b7aa', component.options)
    } else {
      api.reload('45f7b7aa', component.options)
    }
    module.hot.accept("./ExpedientProfitabilityWidget.vue?vue&type=template&id=45f7b7aa&scoped=true", function () {
      api.rerender('45f7b7aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widgets/ExpedientWidgets/ExpedientProfitabilityWidget.vue"
export default component.exports